/**
 * Custom error types for Meframe
 */

/**
 * Error thrown when a clip ready waiter is replaced by a newer one
 * This happens during rapid seeks and should be ignored by callers
 */
export class WaiterReplacedError extends Error {
  constructor(public readonly clipId: string) {
    super(`Waiter for clip ${clipId} was replaced by a newer waiter`);
    this.name = 'WaiterReplacedError';
  }
}
